import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { ExternalLinkTemplateContext, RouterLinkTemplateContext } from '../../header.component';

@Component({
  selector: 'app-staff-user-header',
  templateUrl: './staff-user-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaffUserHeaderComponent {
  @Input()
  public separatorTemplate: TemplateRef<void>;

  @Input()
  public externalLinkTemplate: TemplateRef<ExternalLinkTemplateContext>;

  @Input()
  public routerLinkTemplate: TemplateRef<RouterLinkTemplateContext>;

  @Input()
  public authenticatedUserLinksTemplate: TemplateRef<void>;

  @Input()
  public canAccessOnDemand: boolean;
}
